import { Box, Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import React from "react";
import PropTypes from "prop-types";
import { FaTimes } from "react-icons/fa";
import {TOAST_STYLES} from "@simplified-workspace/shared/util-theme";

function Toast({ status, title, description, onClose }) {
  return (
    <Flex
      zIndex="toast"
      minWidth={280}
      backgroundColor={TOAST_STYLES[status].background}
      boxShadow="md"
      borderRadius={"lg"}
    >
      <Box p={3.5}>
        <Icon
          color={TOAST_STYLES[status].iconColor}
          fontSize="28"
          as={TOAST_STYLES[status].icon}
        />
      </Box>
      <Box py={3.5} flexGrow={1}>
        {title && (
          <Text color={TOAST_STYLES[status].color} fontWeight="bold">
            {title}
          </Text>
        )}
        {description && (
          <Box color={TOAST_STYLES[status].color} fontSize={14}>
            {description}
          </Box>
        )}
      </Box>
      <Box p={3.5}>
        <IconButton
          onClick={onClose}
          aria-label="close toast"
          variant="unstyled"
          size="sm"
        >
          <Icon color={TOAST_STYLES[status].color} fontSize="md" as={FaTimes} />
        </IconButton>
      </Box>
    </Flex>
  );
}

Toast.propTypes = {
  status: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
};
Toast.defaultProps = {
  status: undefined,
  title: undefined,
  description: undefined,
  onClose: undefined,
};

export default Toast;
